<template>
  <transition name="van-fade">
    <div
      v-if="visible"
      @click.stop="handleClick"
      :style="{
        'right': styleRight,
        'bottom': styleBottom
      }"
      class="backtop">
      <slot>
        <van-icon name="back-top" size="16" />
        <span>顶部</span>
      </slot>
    </div>
  </transition>
</template>

<script>
import { throttle } from '@/utils/utils'
const cubic = value => Math.pow(value, 3);
const easeInOutCubic = value => value < 0.5
  ? cubic(value * 2) / 2
  : 1 - cubic((1 - value) * 2) / 2;

export default {
  name: 'Backtop',
  props: {
    visibilityHeight: {
      type: Number,
      default: 200
    },
    target: [String],
    right: {
      type: Number,
      default: 40
    },
    bottom: {
      type: Number,
      default: 40
    }
  },
  data() {
    return {
      el: null,
      container: null,
      visible: false
    };
  },
  computed: {
    styleBottom() {
      return `${this.bottom}px`;
    },
    styleRight() {
      return `${this.right}px`;
    }
  },
  methods: {
    init() {
      this.container = document;
      this.el = document.documentElement;
      if (this.target) {
        this.el = document.querySelector(this.target);
        if (!this.el) {
          throw new Error(`target is not existed: ${this.target}`);
        }
        this.container = this.el;
      }
    },
    onScroll() {
      const scrollTop = this.el.scrollTop || document.body.scrollTop || window.pageYOffset;
      this.visible = scrollTop >= this.visibilityHeight;
    },
    handleClick(e) {
      this.scrollToTop();
      this.$emit('click', e);
    },
    scrollToTop() {
      const top = this.el.getBoundingClientRect().top;
      const pageY = window.pageYOffset;
      const endPosition = top;
      const startTime = +new Date();
      const duration = 500; //ms
      const rAF = window.requestAnimationFrame || (func => setTimeout(func, 16));
      
      function scroll() {
        const time = +new Date() - startTime;
        window.scrollTo(0, pageY + top * (time / duration));
        if (time >= duration) {
          window.scrollTo(0, endPosition);
        } else {
          rAF(scroll);
        }
      }

      rAF(scroll);
    }
  },
  mounted() {
    this.init();
    this.throttledScrollHandler = throttle(this.onScroll, 300);
    this.container.addEventListener('touchmove', this.throttledScrollHandler);
  },
  beforeDestroy() {
    this.container.removeEventListener('touchmove', this.throttledScrollHandler);
  }

}
</script>

<style lang="stylus" scoped>
.backtop
  box-sizing border-box
  position: fixed
  background-color: #0BB78E
  width: 45px
  height: 45px
  border-radius: 50%
  border 1px solid #fff
  color: #fff
  display: flex
  flex-direction column
  align-items: center
  justify-content: center
  font-size: 12px
  box-shadow: 0 0 6px rgba(0,0,0,.12)
  cursor: pointer
  z-index: 5
  span
    margin-top 3px
</style>